// pages/Connector/Channels.js
import React, { useEffect } from "react";
import { Divider, Paper, Grid, Card, CardHeader, CardContent, Typography, Button, Box, useTheme } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import SmsIcon from "@mui/icons-material/Sms";

export default function Channels() {
  const theme = useTheme();

  useEffect(() => {
    document.title = "Channels | KlonIT Web Application";
  }, []);

  return (

    <Paper sx={{ p: 3, mt: 10, mx: "auto", maxWidth: "1200px", bgcolor: "background.paper" }}>
        <Box display="flex" alignItems="center" mb={3}>
            
            <Typography variant="h4" component="h1" fontWeight="bold" color="textPrimary">
            Channels
            </Typography>
        </Box>

        <Divider sx={{ mb: 3 }} />

        <Box component="main" sx={{ p: 3 }}>
        <Box mb={3}>
        </Box>

        <Grid container spacing={3}>
            {/* WhatsApp Bot Card */}
            <Grid item xs={12} md={6} lg={3}>
            <Card
                sx={{
                textAlign: "center",
                borderRadius: 2,
                boxShadow: 3,
                transition: "0.3s",
                "&:hover": { boxShadow: 6 },
                }}
            >
                <CardHeader
                sx={{
                    textAlign: "center",
                    pb: 0,
                }}
                avatar={<WhatsAppIcon sx={{ fontSize: 70, color: theme.palette.success.main }} />}
                />
                <CardContent>
                <Typography variant="h6" fontWeight="600" gutterBottom color="textPrimary">
                    WhatsApp Bot
                </Typography>
                <Typography variant="body2" color="text.secondary" mb={2}>
                    Automate conversations with intelligent chat responses, handling customer queries efficiently.
                </Typography>
                <Button
                    variant="contained"
                    color="primary"
                    href="channels/whatsapp"
                    sx={{ borderRadius: 2 }}
                >
                    Configure
                </Button>
                </CardContent>
            </Card>
            </Grid>

            {/* SMS Bot Card */}
            <Grid item xs={12} md={6} lg={3}>
            <Card
                sx={{
                textAlign: "center",
                borderRadius: 2,
                boxShadow: 3,
                transition: "0.3s",
                "&:hover": { boxShadow: 6 },
                }}
            >
                <CardHeader
                sx={{
                    textAlign: "center",
                    pb: 0,
                }}
                avatar={<SmsIcon sx={{ fontSize: 70, color: theme.palette.info.main }} />}
                />
                <CardContent>
                <Typography variant="h6" fontWeight="600" gutterBottom color="textPrimary">
                    SMS Bot
                </Typography>
                <Typography variant="body2" color="text.secondary" mb={2}>
                    Automate conversations with intelligent chat responses, handling customer queries efficiently.
                </Typography>
                <Button
                    variant="contained"
                    color="primary"
                    href="channels/sms"
                    sx={{ borderRadius: 2 }}
                    
                >
                    Configure
                </Button>
                </CardContent>
            </Card>
            </Grid>
        </Grid>
        </Box>
    </Paper>
  );
}
